import React from 'react';

function Card({id, lines}) {
    return (
        <div className={`loading--card loading--card__${id}`}>
            <div className={'bg--shimmer loading--card--image'} />
            <div className={'loading--card--text'}>
                {Array.from(new Array(lines), (u, index) => (
                    <div
                        className={'bg--shimmer loading--card--text-line'}
                        key={`line--${String(index + 1).padStart(3, '0')}`}
                    />
                ))}
            </div>
        </div>
    );
}

export function CardType1() {
    return <Card id={1} lines={2} />;
}

export function CardType2() {
    return <Card id={2} lines={3} />;
}

export function CardType3() {
    return <Card id={3} lines={4} />;
}
